<template>
	<div class="padding-lg" v-loading="loadingPage">
		<div class="text-xxl">{{ $route.meta.title }}</div>
		<div class="padding-top-xl">
			<div class="flex justify-between">
				<el-form :inline="true" :model="formSearch" class="demo-form-inline">
					<el-form-item label="变动类型">
						<el-select v-model="formSearch.data.type" clearable placeholder="变动类型" style="width: 120px;">
							<el-option label="全部" value=""></el-option>
							<el-option label="入账" :value="1"></el-option>
							<el-option label="出账" :value="2"></el-option>
						</el-select>
					</el-form-item>
					<el-form-item label="变动时间">
						<el-date-picker
							v-model="formSearch.data.addtime"
							type="daterange"
							range-separator="至"
							start-placeholder="开始日期"
							end-placeholder="结束日期"
							value-format="yyyy-MM-dd"
						></el-date-picker>
					</el-form-item>
					<el-form-item><el-button type="primary" @click="loadinfos">查询</el-button></el-form-item>
				</el-form>
			</div>
			<el-table :data="tableData" border style="width: 100%" v-loading="loading" element-loading-text="加载中..." element-loading-spinner="el-icon-loading">
				<el-table-column type="index" align="center" label="序号" width="60"></el-table-column>
				<el-table-column prop="type" align="center" label="变动类型" width="120">
					<template slot-scope="scope">
						<el-tag type="primary" size="small" effect="dark" v-if="scope.row.type == 1">入账</el-tag>
						<el-tag type="warning" size="small" effect="dark" v-else-if="scope.row.type == 2">出账</el-tag>
						<el-tag type="info" size="small" v-else>未知</el-tag>
					</template>
				</el-table-column>
				<el-table-column prop="money" align="right" label="变动金额" width="150">
					<template slot-scope="scope">
						<span class="text-blue text-bold" v-format="'￥,##0.00'" v-if="scope.row.type == 1">{{ scope.row.money / 100 }}</span>
						<span class="text-orange text-bold" v-format="'￥,##0.00'" v-else-if="scope.row.type == 2">{{ scope.row.money / 100 }}</span>
						<span class="text-grey text-bold" v-format="'￥,##0.00'" v-else>{{ scope.row.money / 100 }}</span>
					</template>
				</el-table-column>
				<el-table-column prop="money" align="right" label="变动后结余" width="150">
					<template slot-scope="scope">
						<span class="text-cyan text-bold" v-format="'￥,##0.00'">{{ scope.row.balance / 100 }}</span>
					</template>
				</el-table-column>
				<el-table-column prop="addtime" align="center" label="变动时间" width="180"></el-table-column>
				<el-table-column prop="remark" align="left" label="说明"></el-table-column>
				<el-table-column align="center" label="操作" width="120">
					<template slot-scope="scope">
						<el-button size="small" type="primary" @click="view(scope.$index)">查看</el-button>
					</template>
				</el-table-column>
			</el-table>
			<div class="padding-tb text-right">
				<el-pagination
					background
					@size-change="pageSizeChange"
					@current-change="pageChange"
					:current-page="formSearch.page"
					:page-sizes="[10, 20, 50, 100]"
					:page-size="20"
					layout="total, sizes, prev, pager, next, jumper"
					:total="total"
				></el-pagination>
			</div>
		</div>
		<el-dialog title="查看详情" :visible.sync="dialogView" width="600px">
			<div class="infoshow">
				<div class="title">变动类型：</div>
				<div class="con">
					<el-tag type="primary" size="small" effect="dark" v-if="tableData[viewIndex].type == 1">入账</el-tag>
					<el-tag type="warning" size="small" effect="dark" v-else-if="tableData[viewIndex].type == 2">出账</el-tag>
					<el-tag type="info" size="small" v-else>未知</el-tag>
				</div>
			</div>
			<div class="infoshow">
				<div class="title">变动金额：</div>
				<div class="con">
					<span class="text-blue text-bold" v-format="'￥,##0.00'" v-if="tableData[viewIndex].type == 1">{{ tableData[viewIndex].money / 100 }}</span>
					<span class="text-orange text-bold" v-format="'￥,##0.00'" v-else-if="tableData[viewIndex].type == 2">{{ tableData[viewIndex].money / 100 }}</span>
					<span class="text-grey text-bold" v-format="'￥,##0.00'" v-else>{{ tableData[viewIndex].money / 100 }}</span>
				</div>
			</div>
			<div class="infoshow">
				<div class="title">变动后结余：</div>
				<div class="con">
					<span class="text-cyan text-bold" v-format="'￥,##0.00'">{{ tableData[viewIndex].balance / 100 }}</span>
				</div>
			</div>
			<div class="infoshow">
				<div class="title">变动时间：</div>
				<div class="con">{{ tableData[viewIndex].addtime }}</div>
			</div>
			<div class="infoshow">
				<div class="title">说明信息：</div>
				<div class="con">{{ tableData[viewIndex].remark }}</div>
			</div>
			<el-divider></el-divider>
			<div class="infoshow">
				<div class="title">&nbsp;</div>
				<div class="con"><el-button @click="dialogView=false">关闭</el-button></div>
			</div>
		</el-dialog>
	</div>
</template>

<script>
export default {
	data() {
		return {
			loadingPage: false,
			infos_type: [],
			formSearch: {
				page: 1,
				size: 20,
				data: {
					type:''
				}
			},
			total: 0,
			loading: false,
			tableData: [{
				type:0
			}],
			dialogView: false,
			viewIndex: 0
		};
	},
	beforecreate: function() {},
	created: function() {
		this.loadingPage = true;
		this.$http.post('/server/index.php?m=finance/account/details&a=init', this.formSearch).then(
			res => {
				this.loadingPage = false;
				if (typeof res.data != 'object') {
					this.$alert(res.data ? res.data : '(无返回数据)', {
						title: '返回数据格式错误',
						type: 'error'
					});
				} else {
					if (res.data.result == 'ok') {
						this.loadinfos();
					} else {
						this.$alert(res.data.msg, {
							title: '操作错误',
							type: 'error'
						});
					}
				}
			},
			r => {
				this.loadingPage = false;
				this.$alert('网络错误，指定的服务无法访问。', {
					title: '系统错误',
					type: 'error'
				});
			}
		);
	},
	mounted: function() {},
	updated: function() {},
	methods: {
		loadinfos() {
			var that = this;
			this.loading = true;
			this.$http.post('/server/index.php?m=finance/account/details&a=list', this.formSearch).then(
				res => {
					this.loading = false;
					if (typeof res.data != 'object') {
						this.$alert(res.data ? res.data : '(无返回数据)', {
							title: '返回数据格式错误',
							type: 'error'
						});
					} else {
						if (res.data.result == 'ok') {
							this.total = res.data.data.total;
							this.tableData = res.data.data.infos;
						} else {
							this.$alert(res.data.msg, {
								title: '操作错误',
								type: 'error'
							});
						}
					}
				},
				r => {
					this.loading = false;
					this.$alert('网络错误，指定的服务无法访问。', {
						title: '系统错误',
						type: 'error'
					});
				}
			);
		},
		pageChange(page) {
			this.formSearch.page = page;
			this.loadinfos();
		},
		pageSizeChange(size) {
			this.formSearch.size = size;
			this.loadinfos();
		},
		view(index) {
			this.viewIndex = index;
			this.dialogView = true;
		}
	}
};
</script>

<style></style>
